import {
  getHeightViewportUtil,
  getWidthViewportUtil,
  isLargeScreenViewportUtil,
  isMobileScreenViewportUtil,
  isSmallMobileScreenViewportUtil,
  isTabletScreenViewportUtil,
  isVeryLargeScreenViewportUtil
} from 'modules/viewport/utils.js'
import { createSelector } from 'reselect'

export const isSmallMobileScreenViewportSelect = createSelector(
  state => state && state.viewport,
  viewport => isSmallMobileScreenViewportUtil(viewport)
)

export const isMobileScreenViewportSelect = createSelector(
  state => state && state.viewport,
  viewport => isMobileScreenViewportUtil(viewport)
)

export const isTabletScreenViewportSelect = createSelector(
  state => state && state.viewport,
  viewport => isTabletScreenViewportUtil(viewport)
)

export const isLargeScreenViewportSelect = createSelector(
  state => state && state.viewport,
  viewport => isLargeScreenViewportUtil(viewport)
)

export const isVeryLargeScreenViewportSelect = createSelector(
  state => state && state.viewport,
  viewport => isVeryLargeScreenViewportUtil(viewport)
)

export const getWidthViewportSelect = state => getWidthViewportUtil(
  state && state.viewport
)

export const getHeightViewportSelect = state => getHeightViewportUtil(
  state && state.viewport
)
